<script>
// Ícone do CRM. Reconstruído como rede de 3 nós conectados (2 conectores +
// 3 nós) — diferente do glifo original de path único — para permitir a
// animação de "montar a rede de contatos" (nós surgem em cascata + conectores
// desenhados) na navbar. Silhueta fiel ao original: nó no topo central + dois
// nós na base, formato de relacionamento/compartilhamento. Centros e raio
// idênticos aos do glifo anterior para não alterar o visual em repouso.
// Usado somente na navbar.
export default {
  name: 'CrmIcon',
  props: {
    size: {
      type: [Number, String],
      default: 26,
    },
    color: {
      type: String,
      default: '#ffffff',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- conectores (desenhados por baixo dos nós; os círculos cobrem as pontas) -->
    <line
      class="crm-link"
      x1="6.67"
      y1="2.33"
      x2="2.33"
      y2="11"
      :stroke="color"
      stroke-width="1.6"
      stroke-linecap="round"
    />
    <line
      class="crm-link"
      x1="6.67"
      y1="2.33"
      x2="11"
      y2="11"
      :stroke="color"
      stroke-width="1.6"
      stroke-linecap="round"
    />
    <!-- nós: topo, inferior-esquerdo, inferior-direito -->
    <circle class="crm-node" cx="6.67" cy="2.33" r="2.33" :fill="color" />
    <circle class="crm-node" cx="2.33" cy="11" r="2.33" :fill="color" />
    <circle class="crm-node" cx="11" cy="11" r="2.33" :fill="color" />
  </svg>
</template>
